export default "__VITE_ASSET__ed678960__"